import React from 'react';
import { RichUtils } from 'draft-js';
import { AiOutlineUnorderedList, AiOutlineOrderedList } from 'react-icons/ai';
import { eventNames } from '../../../../config';
import BaseGroupBlock from '../BaseGroupBlock';

const items = [
  {
    inlineStyle: 'unordered-list-item',
    tooltipTitle: 'Маркированный список',
    children: <AiOutlineUnorderedList />,
  },
  {
    inlineStyle: 'ordered-list-item',
    tooltipTitle: 'Нумерованный список',
    children: <AiOutlineOrderedList />,
  },
];

const isActive = (watchedValue, value) => watchedValue === value;

const ListGroupBlock = () => {
  return (
    <BaseGroupBlock
      items={items}
      evtName={eventNames.blockTypeChange}
      isActive={isActive}
      getNewState={RichUtils.toggleBlockType}
    />
  );
};

export default ListGroupBlock;
